// extracted by mini-css-extract-plugin
export var link = "socialLinks-module--link--FQPek";
export var linkList = "socialLinks-module--linkList--ZzLSP";